<template>
    <div class="locations-container">
        <div class="locations-header">
            <h1 class="locations-title">Puntos de Recolección y Entrega</h1>
            <p class="locations-subtitle">Encuentra el punto más cercano para dejar y recoger tus gorras</p>
        </div>

        <div class="locations-content">
            <!-- Taller Principal -->
            <div class="main-location">
                <div class="location-card featured">
                    <div class="location-badge">
                        <i class="fa fa-star"></i>
                        Taller Principal
                    </div>
                    <div class="location-content">
                        <div class="location-info">
                            <h3 class="location-name">
                                <i class="fa fa-home"></i>
                                Naucalpan de Juárez, Edo. Méx.
                            </h3>
                            <p class="location-description text-white">
                                Nuestro taller principal ubicado cerca de los arcos, del CCH Naucalpan hacia arriba.
                            </p>
                            <div class="location-details">
                                <div class="detail-item">
                                    <i class="fa fa-clock"></i>
                                    <span>Horario: Lunes a Sábado 9:00 AM - 6:00 PM</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fa fa-phone"></i>
                                    <span>Recolección y entrega directa</span>
                                </div>
                                <div class="detail-item">
                                    <i class="fa fa-map-marker-alt"></i>
                                    <span>Cerca de CCH Naucalpan</span>
                                </div>
                            </div>
                        </div>
                        <div class="location-map-preview">
                            <iframe 
                                :src="locations.taller.iframeUrl"
                                class="map-iframe"
                                loading="lazy"
                                allowfullscreen
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Taller Principal Naucalpan"
                            ></iframe>
                            <div class="map-iframe-overlay" @click="openFullMap(locations.taller)">
                                <i class="fa fa-expand-alt"></i>
                                <span>Ver mapa completo</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Puntos de Colaboración -->
            <div class="collaboration-section">
                <h2 class="section-title">
                    <i class="fa fa-handshake"></i>
                    Puntos de Colaboración
                </h2>
                <p class="container">
                    También funcionamos encontrando a los clientes en puntos medios en CDMX y área metropolitana
                </p>

                <div class="collaboration-grid">
                    <div 
                        v-for="(location, index) in locations.colaboradores" 
                        :key="index"
                        class="location-card collaboration"
                    >
                        <div class="location-header">
                            <h4 class="location-name">
                                <i class="fa fa-store"></i>
                                {{ location.nombre }}
                            </h4>
                            <span class="location-city">{{ location.ciudad }}</span>
                        </div>
                        
                        <!-- Vista previa con iframe -->
                        <div class="location-map-preview">
                            <iframe 
                                :src="location.iframeUrl"
                                class="map-iframe"
                                loading="lazy"
                                allowfullscreen
                                referrerpolicy="no-referrer-when-downgrade"
                                :title="'Mapa de ' + location.nombre"
                            ></iframe>
                            <div class="map-iframe-overlay" @click="openFullMap(location)">
                                <i class="fa fa-expand-alt"></i>
                                <span>Ver mapa completo</span>
                            </div>
                        </div>
                        
                        <p class="location-description">{{ location.descripcion }}</p>
                        
                        <div class="location-details">
                            <div class="detail-item">
                                <i class="fa fa-map-pin"></i>
                                <span>{{ location.direccion }}</span>
                            </div>
                            <div class="detail-item">
                                <i class="fa fa-clock"></i>
                                <span>{{ location.horario }}</span>
                            </div>
                        </div>

                        <div class="location-actions">
                            <button class="btn-map" @click="openFullMap(location)">
                                <i class="fa fa-map-marked-alt"></i>
                                Ver en Maps
                            </button>
                            <button class="btn-whatsapp" @click="contactarWhatsApp(location)">
                                <i class="fa fa-whatsapp"></i>
                                Contactar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Información Adicional -->
            <div class="additional-info">
                <div class="info-card">
                    <div class="info-icon">
                        <i class="fa fa-route"></i>
                    </div>
                    <div class="info-content">
                        <h3>¿No encuentras un punto cercano?</h3>
                        <p>Cuéntanos dónde te ubicas y te recomendamos el punto de recolección más conveniente o acordamos uno.</p>
                        <button class="btn-contact" @click="contactarAsesor">
                            <i class="fa fa-comments"></i>
                            Contactar a un Asesor
                        </button>
                    </div>
                </div>
            </div>

            <!-- Modal para mapa completo -->
            <div v-if="selectedLocation" class="modal-overlay" @click="selectedLocation = null">
                <div class="modal-content" @click.stop>
                    <button class="modal-close" @click="selectedLocation = null">
                        <i class="fa fa-times"></i>
                    </button>
                    <h3 class="modal-title">{{ selectedLocation.nombre }}</h3>
                    <p class="modal-subtitle">{{ selectedLocation.ciudad }}</p>
                    
                    <div class="modal-map-container">
                        <iframe 
                            :src="selectedLocation.iframeUrl"
                            class="modal-map-iframe"
                            loading="lazy"
                            allowfullscreen
                            referrerpolicy="no-referrer-when-downgrade"
                            :title="'Mapa completo de ' + selectedLocation.nombre"
                        ></iframe>
                    </div>
                    
                    <div class="modal-actions">
                        <a :href="selectedLocation.mapsUrl" target="_blank" class="btn-modal-action">
                            <i class="fa fa-external-link-alt"></i>
                            Abrir en Google Maps
                        </a>
                        <button class="btn-modal-action" @click="obtenerRuta">
                            <i class="fa fa-directions"></i>
                            Cómo llegar
                        </button>
                        <button class="btn-modal-action btn-whatsapp" @click="contactarWhatsApp(selectedLocation)">
                            <i class="fa fa-whatsapp"></i>

                            Contactar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LocationsComponent',
    data() {
        return {
            selectedLocation: null,
            locations: {
                taller: {
                    nombre: "Taller Principal",
                    ciudad: "Naucalpan de Juárez, Edo. Méx.",
                    descripcion: "Nuestro taller principal ubicado cerca de los arcos, del CCH Naucalpan hacia arriba.",
                    mapsUrl: "https://www.google.com/maps/place/19°27'36.6%22N+99°16'39.8%22W/@19.460169,-99.277717,17z/data=!3m1!4b1!4m4!3m3!8m2!3d19.4601692!4d-99.2777172?hl=es&entry=ttu",
                    iframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.326849955755!2d-99.2802921!3d19.4601692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d2021241744b21%3A0xdfe30053aa175273!2s19%C2%B027'36.6%22N%2099%C2%B016'39.8%22W!5e0!3m2!1ses!2smx!4v1700000000000!5m2!1ses!2smx",
                    horario: "Lunes a Sábado 9:00 AM - 6:00 PM",
                    direccion: "Cerca de los arcos, CCH Naucalpan",
                    coordenadas: "19.4601692,-99.2777172",
                    tipo: "taller"
                },
                colaboradores: [
{
    "nombre": "The Laikans Barber Shop",
    "ciudad": "Cuautitlán Izcalli",
    "descripcion": "Punto de recolección en barbería especializada.",
    "direccion": "The Laikans Barber Shop",
    "mapsUrl": "https://maps.app.goo.gl/JstcNVQNbn6V7SCQA",
    "iframeUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3760.155484345362!2d-99.240023!3d19.571646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21e9e6b2b2b2b%3A0x8c3b3b3b3b3b3b3b!2sThe%20Laikans%20Barber%20Shop!5e0!3m2!1sen!2smx!4v1234567890!5m2!1sen!2smx",
    "horario": "Horario del establecimiento",
    "coordenadas": {
        "lat": 19.571646,
        "lng": -99.240023
    },
    "tipo": "colaborador"
},
                    {
                        nombre: "Pet Life",
                        ciudad: "Tlalnepantla, Valle Dorado",
                        descripcion: "Punto de recolección antes de La Quebrada.",
                        direccion: "Valle Dorado antes de La Quebrada",
                        mapsUrl: "https://www.google.com/maps/place/Pet+Life/@19.5533811,-99.2103765,17z/data=!3m1!4b1!4m6!3m5!1s0x85d21d265cac5017:0x80166c0add31b155!8m2!3d19.5533811!4d-99.2103765!16s%2Fg%2F11h0mpk816?hl=es&entry=ttu",
                        iframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.2734272994423!2d-99.2129664!3d19.5533811!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21d265cac5017%3A0x80166c0add31b155!2sPet%20Life!5e0!3m2!1ses!2smx!4v1700000000000!5m2!1ses!2smx",
                        horario: "Horario del establecimiento",
                        coordenadas: "19.5533811,-99.2103765",
                        tipo: "colaborador"
                    },
                    {
                        nombre: "NanDann Autogarage",
                        ciudad: "Gustavo A. Madero",
                        descripcion: "Punto de recolección cerca de la Basílica.",
                        direccion: "Fausto Romero 30, Aragón La Villa",
                        mapsUrl: "https://www.google.com/maps/place/NanDann+autogarage/@19.4768428,-99.1234786,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f7c5c6f0c8f3:0x71e74932c77a9740!8m2!3d19.4768428!4d-99.1209037!16s%2Fg%2F11h0mpl6zv?hl=es&entry=ttu",
                        iframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.5897097641194!2d-99.1234786!3d19.4768428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f7c5c6f0c8f3%3A0x71e74932c77a9740!2sNanDann%20autogarage!5e0!3m2!1ses!2smx!4v1700000000000!5m2!1ses!2smx",
                        horario: "Horario del establecimiento",
                        coordenadas: "19.4768428,-99.1209037",
                        tipo: "colaborador"
                    },
                    {
                        nombre: "Torres Demet",
                        ciudad: "Miguel Hidalgo",
                        descripcion: "Punto de recolección frente al Mexipuerto Cuatro Caminos Toreo.",
                        direccion: "Frente al Mexipuerto Cuatro Caminos Toreo",
                        mapsUrl: "https://www.google.com/maps/place/Carpa+torres+demet+toreo+II/@19.4564371,-99.2141525,17z/data=!3m1!4b1!4m6!3m5!1s0x85d203007d83f1ad:0x74de81164e6bd79c!8m2!3d19.4564371!4d-99.2141525!16s%2Fg%2F11y8lshlts?hl=es&entry=ttu",
                        iframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.551568435985!2d-99.2167274!3d19.4564371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d203007d83f1ad%3A0x74de81164e6bd79c!2sCarpa%20torres%20demet%20toreo%20II!5e0!3m2!1ses!2smx!4v1700000000000!5m2!1ses!2smx",
                        horario: "Horario del establecimiento",
                        coordenadas: "19.4564371,-99.2141525",
                        tipo: "colaborador"
                    }
                ]
            }
        };
    },
    methods: {
        openFullMap(location) {
            this.selectedLocation = location;
        },
        
        obtenerRuta() {
            if (this.selectedLocation) {
                const rutaUrl = `https://www.google.com/maps/dir/?api=1&destination=${this.selectedLocation.coordenadas}`;
                window.open(rutaUrl, '_blank');
            }
        },
        
        contactarWhatsApp(location) {
            const message = `Hola, me interesa conocer más información sobre el punto de recolección:\n\n📍 *${location.nombre}*\n🏙️ ${location.ciudad}\n📌 ${location.direccion}\n\n¿Podrían darme más detalles?`;
            const whatsappUrl = `https://wa.me/525533138568?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, '_blank');
        },
        
        contactarAsesor() {
            const message = "Hola, me gustaría recibir asesoría para encontrar el punto de recolección más cercano a mi ubicación.";
            const whatsappUrl = `https://wa.me/525533138568?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, '_blank');
        }
    }
};
</script>

<style scoped>
.locations-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

.locations-header {
    text-align: center;
    margin-bottom: 50px;
}

.locations-title {
    font-size: 2.8rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 15px;
    background: linear-gradient(135deg, #3498db, #2980b9);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.locations-subtitle {
    font-size: 1.2rem;
    color: #000;
    font-weight: 300;
    max-width: 600px;
    margin: 0 auto;
}

/* Taller Principal */
.main-location {
    margin-bottom: 50px;
}

.location-card.featured {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 20px;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
}

.location-badge {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    padding: 10px 20px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-radius: 0 0 15px 0;
    font-weight: 600;
    font-size: 0.9rem;
}

.location-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    padding: 30px;
}

.location-info h3 {
    font-size: 1.5rem;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.location-description {
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 20px;
    opacity: 0.9;
}

.location-details {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.95rem;
}

/* Vista previa con iframe */
.location-map-preview {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    overflow: hidden;
    border: 3px solid rgba(255, 255, 255, 0.3);
}

.map-iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 12px;
}

.map-iframe-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    color: white;
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;
    border-radius: 12px;
}

.map-iframe-overlay:hover {
    opacity: 1;
}

/* Colaboración Section */
.collaboration-section {
    margin-bottom: 50px;
}

.section-title {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.section-description {
    color: #7f8c8d;
    font-size: 1.1rem;
    margin-bottom: 30px;
}

.collaboration-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 25px;
}

.location-card.collaboration {
    background: white;
    border-radius: 15px;
    padding: 25px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
}

.location-card.collaboration:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.location-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 15px;
    gap: 10px;
}

.location-header h4 {
    font-size: 1.2rem;
    color: #2c3e50;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.location-city {
    background: #e8f4fd;
    color: #3498db;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 600;
}

.location-map-preview {
    height: 180px;
    margin-bottom: 15px;
    border: 2px solid #f0f0f0;
}

.location-description {
    flex-grow: 1;
    margin-bottom: 15px;
    color: #666;
}

.location-actions {
    display: flex;
    gap: 10px;
    margin-top: auto;
}

.btn-map {
    background: #3498db;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    transition: background 0.3s ease;
    flex: 1;
    justify-content: center;
    cursor: pointer;
}

.btn-map:hover {
    background: #2980b9;
}

.btn-whatsapp {
    background: #25d366;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    transition: background 0.3s ease;
    flex: 1;
    justify-content: center;
    cursor: pointer;
}

.btn-whatsapp:hover {
    background: #128c7e;
}

/* Additional Info */
.additional-info {
    margin-top: 40px;
}

.info-card {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
    border-radius: 20px;
    padding: 30px;
    display: flex;
    align-items: center;
    gap: 25px;
    box-shadow: 0 15px 35px rgba(240, 147, 251, 0.3);
}

.info-icon {
    font-size: 3rem;
    opacity: 0.9;
}

.info-content h3 {
    font-size: 1.5rem;
    margin-bottom: 10px;
}

.info-content p {
    font-size: 1.1rem;
    opacity: 0.9;
    margin-bottom: 20px;
    line-height: 1.5;
}

.btn-contact {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    padding: 12px 25px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-contact:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
}

/* Modal para mapa completo */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.modal-content {
    background: white;
    border-radius: 20px;
    width: 90%;
    max-width: 900px;
    max-height: 90vh;
    overflow: auto;
    position: relative;
    padding: 30px;
}

.modal-close {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #ff4757;
    color: white;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.2rem;
    z-index: 1001;
    transition: background 0.3s ease;
}

.modal-close:hover {
    background: #ff3742;
}

.modal-title {
    font-size: 1.8rem;
    color: #2c3e50;
    margin-bottom: 5px;
}

.modal-subtitle {
    color: #7f8c8d;
    margin-bottom: 20px;
    font-size: 1.1rem;
}

.modal-map-container {
    width: 100%;
    height: 400px;
    border-radius: 15px;
    overflow: hidden;
    margin-bottom: 20px;
    border: 2px solid #f0f0f0;
}

.modal-map-iframe {
    width: 100%;
    height: 100%;
    border: none;
}

.modal-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-modal-action {
    background: #3498db;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    cursor: pointer;
    text-decoration: none;
    flex: 1;
    justify-content: center;
    min-width: 200px;
}

.btn-modal-action:hover {
    background: #2980b9;
    transform: translateY(-2px);
}

.btn-modal-action.btn-whatsapp {
    background: #25d366;
}

.btn-modal-action.btn-whatsapp:hover {
    background: #128c7e;
}

/* Responsive Design */
@media (max-width: 768px) {
    .locations-container {
        padding: 30px 15px;
    }
    
    .locations-title {
        font-size: 2.2rem;
    }
    
    .locations-subtitle {
        font-size: 1.1rem;
    }
    
    .location-content {
        grid-template-columns: 1fr;
        gap: 20px;
        padding: 20px;
    }
    
    .location-map-preview {
        height: 200px;
    }
    
    .collaboration-grid {
        grid-template-columns: 1fr;
    }
    
    .info-card {
        flex-direction: column;
        text-align: center;
        gap: 20px;
        padding: 20px;
    }
    
    .location-actions {
        flex-direction: column;
    }
    
    .section-title {
        font-size: 1.6rem;
    }
    
    .modal-content {
        padding: 20px;
        width: 95%;
    }
    
    .modal-map-container {
        height: 300px;
    }
    
    .btn-modal-action {
        min-width: 100%;
    }
}

@media (max-width: 480px) {
    .locations-title {
        font-size: 1.8rem;
    }
    
    .location-card.collaboration {
        padding: 20px;
    }
    
    .location-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .location-city {
        align-self: flex-start;
    }
    
    .info-card {
        padding: 15px;
    }
    
    .btn-contact {
        width: 100%;
        justify-content: center;
    }
    
    .modal-content {
        padding: 15px;
    }
    
    .modal-map-container {
        height: 250px;
    }
}

/* Animación de entrada */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.location-card {
    animation: fadeIn 0.5s ease-out;
}
</style>